import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useAuth } from "../supabase/auth/AuthContext/useAuth";

export const useSentryTags = () => {
  const { user } = useAuth();
  const userId = user?.id;
  useEffect(() => {
    Sentry.setUser({ id: userId });
  }, [userId]);
};
